import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { KhachHangModel } from '../khach-hang-model/khach-hang.model';
const API_ROOT_URL = environment.ApiRoot + '/khachhang';
@Injectable()
export class KhachHangService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }
	getData(queryParams: QueryParamsModel): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/KhachHangNew_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	getKhachHangById(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/KhachHangNew_Detail?IdKh=${itemId}`,{ headers: httpHeaders });
	}
	deleteKhachHang(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/KhachHangNew_Delete?IdKh=${itemId}`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	deleteKhachHangs(ids: any[] = []): Observable<any> {
		const url = API_ROOT_URL + '/deleteSelect';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<QueryResultsModel>(url, ids, { headers: httpHeaders });
	}
	createKhachHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhachHangModel>(API_ROOT_URL + '/KhachHangNew_Insert', item, { headers: httpHeaders });
	}
	updateKhachHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhachHangModel>(API_ROOT_URL + '/KhachHangNew_Update', item, { headers: httpHeaders });
	}
	//#region ***filter***
	getFilterGroup(column: string, url: string): Observable<any> {
		return this.http.get<any>(environment.ApiRoot + url + `${column}`);
	}
	uploadFileKhachHang(data): Observable<any> {
		const url = API_ROOT_URL + '/DM_LoaiThanhPham_UploadFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	importKhachHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhachHangModel>(API_ROOT_URL + '/DM_LoaiThanhPham_Import', item, { headers: httpHeaders });
	}
	
	listIdLoaikh(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + '/LoaiKhachHang_List';
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	listIdTinh(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + '/TinhThanh_List';
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	listNvkinhdoanh(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + '/NhanVien_List';
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	listIdKv(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + '/KhuVuc_List';
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	listIdKhparent(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + '/KhachHangNew_List';
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	
	listIdHuyen(IdTinhValue: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/QuanHuyen_List?IdTinh=${IdTinhValue}` ;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	
	 // Import hh
	 downloadTemplate(): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<Blob>(API_ROOT_URL + '/DownLoadFileImportMau', {
		  headers: httpHeaders,
		  responseType: 'blob' as 'json'
		});
	}
	
	uploadFileImport(data): Observable<any> {
		const url = API_ROOT_URL + '/ImportFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	
	createMultiple(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/DM_Mutiple_Insert', item, { headers: httpHeaders });
	}
	
	getDanhSachMa(): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + '/DM_MaKHLite', {
			headers: httpHeaders,
		});
	}
  
	exportFileExcel(queryParams: QueryParamsModel): Observable<Blob>{
		
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<Blob>(API_ROOT_URL + '/ExportFile', {
			headers: httpHeaders,
			params: httpParams,
			responseType: 'blob' as 'json'
		});
	}
}
